import { ApolloError } from "@apollo/client";

import { safeToastMessage } from "./safeToastMessage";

const REVIEW_TRANSITION_ERROR_CODES = new Set([
  "DIGITAL_SIGNATURE_NOT_PREPARED",
  "DIGITAL_SIGNATURE_PENDING_SIGNERS",
]);

/**
 * Inspect an unknown error returned by an Apollo mutation. If it carries a
 * GraphQL error whose `extensions.code` is one of our review-transition
 * codes, return the user-safe (single-line, length-capped) message. Otherwise
 * return null and the caller should show a generic error toast.
 *
 * Extracted from ReadOnlySubmission's review-submit catch block so it can be
 * unit-tested without standing up the full route.
 */
export function pickTransitionErrorMessage(error: unknown): string | null {
  if (!(error instanceof ApolloError)) {
    return null;
  }
  const transitionGqlError = error.graphQLErrors.find((e) => {
    const code = e.extensions?.code;
    return typeof code === "string" && REVIEW_TRANSITION_ERROR_CODES.has(code);
  });
  if (!transitionGqlError) {
    return null;
  }
  return safeToastMessage(transitionGqlError.message);
}
